export default __webpack_public_path__ + "static/media/thumbnail.377acdd8.png";